module.exports = __webpack_public_path__ + "img/TikTok.2048c1c5.svg";